import { combineReducers } from 'redux'
import { modalActions } from 'store/modal'
import { authActions } from 'store/user'
import request from 'utils/request'
import { formatEventBody } from 'utils/events'
import { onFetchConsent } from '../../Consent/modules/Consent'

import packageJson from '../../../../package.json'

const UPDATE_USERNAME_FIELD = 'UPDATE_USERNAME_FIELD'
const UPDATE_PASSWORD_FIELD = 'UPDATE_PASSWORD_FIELD'
const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR'
const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR'
export const SET_TEMP_PASSWORD = 'SET_TEMP_PASSWORD'
const CLEAR_TEMP_PASSWORD = 'CLEAR_TEMP_PASSWORD'

const LOGIN_ERRORS = {
  400: 'Your username or password is incorrect. Please try again.',
  500: 'Oh, shoot. Something went wrong on our server, and we’re fixing it! Please try again later.'
}

function updateUsername(payload) {
  return {
    type: UPDATE_USERNAME_FIELD,
    payload
  }
}

function updatePassword(payload) {
  return {
    type: UPDATE_PASSWORD_FIELD,
    payload
  }
}

const setLoginError = (response, message, strings) => {
  const getLoginError = (status = 400) => {
    if (status === 400) return strings?.error_login_400
    if (status === 500) return strings?.error_login_500
    return LOGIN_ERRORS[status]
  }

  return {
    type: SET_LOGIN_ERROR,
    payload: getLoginError(response.status)
  }
}

const clearLoginError = () => {
  return {
    type: CLEAR_LOGIN_ERROR
  }
}

const setTempPassword = payload => {
  return {
    type: SET_TEMP_PASSWORD,
    payload
  }
}

const clearTempPassword = () => {
  return {
    type: CLEAR_TEMP_PASSWORD
  }
}

function forgotPassword(userName) {
  return dispatch => {
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/forgot_password',
        body: JSON.stringify({ username: userName }),
        authRequired: false,
        skipNotyFail: true
      })
    )
  }
}

function forgotUsername(email) {
  return dispatch => {
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/forgot_username',
        body: JSON.stringify({ email }),
        authRequired: false,
        skipNotyFail: true
      })
    )
  }
}

function onAppOpened() {
  return dispatch => {
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/events',
        body: formatEventBody('APP_OPENED'),
        success: () => { }
      })
    )
  }
}

let syncRequestInFlight = false

// Skip sync if we already have latest_app_version or a request is in flight (avoids duplicate calls from multiple routes)
export function onFetchSyncStudyConfig() {
  return (dispatch, getState) => {
    if (getState().user?.latest_app_version || syncRequestInFlight) {
      return Promise.resolve()
    }
    syncRequestInFlight = true
    return dispatch(
      request({
        method: 'GET',
        url: '/control/participants/me/sync',
        headerOptions: {
          'hpi-device-type': 'web',
          'hpi-app-version': packageJson.version
        },
        hasLoader: true,
        success: json => {
          const { participant_info = {}, latest_app_version } = json || {}
          const userData = {
            ...participant_info,
            latest_app_version
          }
          dispatch(authActions.setUserData(userData))
        }
      })
    ).finally(() => {
      syncRequestInFlight = false
    })
  }
}

// reducers

function username(state = '', { type, payload }) {
  if (type === UPDATE_USERNAME_FIELD) {
    return payload
  }
  return state
}

function password(state = '', { type, payload }) {
  if (type === UPDATE_PASSWORD_FIELD) {
    return payload
  }
  return state
}

function tempPassword(state = localStorage.getItem('temp'), { type, payload }) {
  switch (type) {
    case SET_TEMP_PASSWORD: {
      localStorage.setItem('temp', payload)
      return payload || ''
    }
    case CLEAR_TEMP_PASSWORD:
      localStorage.removeItem('temp')
      return ''
    default:
      return state
  }
}

function loginError(state = '', { type, payload }) {
  switch (type) {
    case SET_LOGIN_ERROR: {
      return payload || ''
    }
    case CLEAR_LOGIN_ERROR:
      return ''
    default:
      return state
  }
}

export const actions = {
  updateUsername,
  updatePassword,
  forgotPassword,
  forgotUsername,
  setLoginError,
  clearLoginError,
  setTempPassword,
  clearTempPassword,
  onAppOpened,
  onFetchSyncStudyConfig,
  onFetchConsent,
  openModal: modalActions.openModal,
  closeModal: modalActions.closeModal
}

export default combineReducers({ username, password, tempPassword, loginError })
